import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const Provider = {
  id: 'provider',
  displayName: <FormattedMessage {...messages.provider} />,
  type: OptionFormTypes.TYPE_CHECKLIST,
  filterValue: 'labelProviderId',
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },

  shouldHideActionButtons: true,
};
